/**
 * Returns the doctor's name exactly as it is without forcing a "Dr." prefix.
 */
export const formatDoctorName = (name?: string | null): string => {
  const raw = (name ?? '').trim();
  if (!raw) return '';
  return raw;
};

/**
 * Normalises and returns the list of doctor specialities, removing
 * empties / duplicates while preserving order.
 */
export const getDoctorSpecialities = (value: unknown): string[] => {
  const collect = (input: unknown): string[] => {
    if (Array.isArray(input)) {
      return input.flatMap((item) => collect(item));
    }
    if (typeof input === 'string') {
      const trimmed = input.trim();
      if (!trimmed) return [];
      if (trimmed.startsWith('[') || trimmed.startsWith('{')) {
        try {
          return collect(JSON.parse(trimmed));
        } catch {
          return [trimmed];
        }
      }
      // Allow comma-separated strings such as "Cardiology, Pediatrics"
      return trimmed
        .split(',')
        .map((part) => part.trim())
        .filter((part) => part.length > 0);
    }
    if (input && typeof input === 'object') {
      const raw = input as Record<string, unknown>;
      if (typeof raw.speciality === 'string') return collect(raw.speciality);
      if (typeof raw.specialization === 'string') return collect(raw.specialization);
    }
    return [];
  };
  const seen = new Set<string>();
  const out: string[] = [];
  for (const item of collect(value)) {
    const key = item.toLowerCase();
    if (seen.has(key)) continue;
    seen.add(key);
    out.push(item);
  }
  return out;
};

/**
 * Joins the doctor's specialities into a single display string.
 */
export const formatDoctorSpecialities = (value: unknown, separator: string = ', '): string => {
  return getDoctorSpecialities(value).join(separator);
};
